import React from "react";

import Butterfly from "@/assets/images/butterfly.svg?react";
import Cat from "@/assets/images/cat.svg?react";
import Crab from "@/assets/images/crab.svg?react";
import Elephant from "@/assets/images/elephant.svg?react";
import Fish from "@/assets/images/fish.svg?react";
import Fox from "@/assets/images/fox.svg?react";
import Bird from "@/assets/images/bird.svg?react";
import Bison from "@/assets/images/bison.svg?react";
import Beetle from "@/assets/images/beetle.svg?react";

import Asset1 from "@/assets/images/asset1.svg?react";
import Asset2 from "@/assets/images/asset2.svg?react";
import Asset3 from "@/assets/images/asset3.svg?react";
import Asset4 from "@/assets/images/asset4.svg?react";
import Asset5 from "@/assets/images/asset5.svg?react";
import Asset6 from "@/assets/images/asset6.svg?react";
import Asset7 from "@/assets/images/asset7.svg?react";
import Asset8 from "@/assets/images/asset8.svg?react";
import Asset9 from "@/assets/images/asset9.svg?react";
import Asset10 from "@/assets/images/asset10.svg?react";
import Asset11 from "@/assets/images/asset11.svg?react";
import Asset12 from "@/assets/images/asset12.svg?react";

export const ICON_COLORS = [
  "hsl(195, 55%, 75%)", // Sky
  "hsl(185, 45%, 72%)", // Ice
  "hsl(210, 40%, 78%)", // Frost
  "hsl(340, 50%, 78%)", // Dawn
  "hsl(280, 45%, 75%)", // Aurora
  "hsl(45, 60%, 75%)", // Golden
  "hsl(25, 55%, 76%)", // Ember
  "hsl(355, 50%, 78%)", // Berry
];

const ASSET_MAP: Record<string, React.ComponentType> = {
  butterfly: Butterfly,
  cat: Cat,
  crab: Crab,
  elephant: Elephant,
  fish: Fish,
  fox: Fox,
  bird: Bird,
  bison: Bison,
  beetle: Beetle,
};

export const TEAM_ASSETS = Object.keys(ASSET_MAP);

const NUMBERED_ASSETS: React.ComponentType[] = [
  Asset1,
  Asset2,
  Asset3,
  Asset4,
  Asset5,
  Asset6,
  Asset7,
  Asset8,
  Asset9,
  Asset10,
  Asset11,
  Asset12,
].filter(Boolean);

interface AssetIconProps {
  size?: "sm" | "md" | "lg";
  className?: string;
  color: string | undefined;
  asset?: string;
  iconIndex?: number;
}

export const AssetIcon: React.FC<AssetIconProps> = ({
  size = "md",
  className = "",
  color,
  asset,
  iconIndex,
}) => {
  const sizeClasses = {
    sm: "w-4 h-4",
    md: "w-6 h-6",
    lg: "w-8 h-8",
  };

  let AssetComponent:
    | React.ComponentType<{ className?: string; style?: React.CSSProperties }>
    | undefined;

  if (asset && ASSET_MAP[asset]) {
    AssetComponent = ASSET_MAP[asset];
  } else if (
    iconIndex !== undefined &&
    iconIndex >= 0 &&
    iconIndex < NUMBERED_ASSETS.length &&
    NUMBERED_ASSETS[iconIndex]
  ) {
    AssetComponent = NUMBERED_ASSETS[iconIndex];
  }

  if (!AssetComponent) {
    AssetComponent = NUMBERED_ASSETS[0];
  }

  return (
    <div
      className={`${sizeClasses[size]} flex items-center justify-center shrink-0 ${className}`}
    >
      <div className={`${sizeClasses[size]} flex items-center justify-center`}>
        <AssetComponent
          className="w-full h-full icon-svg"
          style={
            {
              "--icon-color": color || ICON_COLORS[0],
            } as React.CSSProperties
          }
        />
      </div>
    </div>
  );
};

export { ICON_COLORS as TEAM_COLORS };

export const MODEL_COLORS = [...ICON_COLORS];

export const NUMBERED_ASSET_COUNT = NUMBERED_ASSETS.length;
